
<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" margin= "auto">
      <div 
        style="width:300px"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
      <CCard>
          <CCardBody class="modal-body" id="modalDescription">
              <CRow>
                <CCol col="8">
                    <h4 id="traffic" class="card-title mb-0">Export Data</h4>
                </CCol>
                <CCol col="4">
                  
                  
                    <CButton id="btn-close1" class="float-right" 
                    @click="close">  
                        
                          <CIcon name = cilX></CIcon> 
                          
                        
                     </CButton> 
                </CCol>
              </CRow>

              <CRow id = "rowfont">
                <CCol col="12">
                      <label class="col-form-label-sm">Date Range :</label><br>
                      <date-range-picker
                        dateRange
                        @update="defaultDateRangePickerUpdateEvent"
                        :ranges="getDefaultDateRange()"
                         >
                      <div slot="input" slot-scope="picker">
                          <span v-if="picker.startDate!=null">{{ picker.startDate|moment("MMM Do YYYY HH:mm:ss")}} - {{ picker.endDate|moment("MMM Do YYYY HH:mm:ss")}}</span>
                      </div>
                      </date-range-picker>        
                      </CCol> 
              </CRow>

              <CRow>
                    <CCol col="12">
                      <label  class="col-form-label-sm">File Type :</label>
                      <treeselect
                      :multiple="false"
                      :options="options"
                      placeholder=""
                      v-model="Options"
                      />
                    </CCol>
              </CRow>

              <CRow>
                  <CCol col="3" md="2"  class="mb-3 mb-xl-0" margin="auto">
                    <CButton block color="success" size="sm" style="margin-top:20px"><span style="margin-right: 5px;">
                      Export</span></CButton>
                </CCol>
              </CRow>
          </CCardBody>
      </CCard>
      </div>
    </div>
  </transition>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from "moment";

var a=0;
  export default {
    methods: {
      close() {
        this.$parent.isModalVisible=!this.$parent.isModalVisible;
      },
      getdate() {
        }
    },
    data(){
        return{
        isable:false,
        Options:null,
        options:[{id:'xls',label:'xls'},{id:'pdf',label:'pdf'}]
        }
    },
    components:{
      DateRangePicker,
      Treeselect
    },
    mounted(){
        this.getdate()
    },

};
  
</script>
<style>
  .modal-backdrop {
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    position: fixed;
    overflow: visible;
  }

  .modal {
    background: #FFFFFF;
    max-width: 55%;
    box-shadow: 2px 2px 20px 1px;
    display: flex;
    flex-direction: column;
    margin-left: 25%;
    margin-top: 10%;
    display:inline-flex;
    white-space: nowrap ;
    height: fit-content;
    overflow: visible !important;
  }

  #btn-close1 {
    border: none;
    font-size: 15px;
    padding: 0 ;
    cursor: pointer;
    font-weight: bold;
    background-color: "#ff0000";
    min-width: 10px;
    min-height: 15px;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
  #rowfont{
      color: black;
  }
  #csel{
    margin-left: 20px;;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderDropdown/Modal.vue